import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import {
	Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import CryptoJS from 'crypto-js'
import moment from 'moment'
import Loader from './../shared/loader'

export default {
	name: 'stocktransfer',
	components: {
		Paginate,
		DatePicker,
		Loader
	},
	data: function() {
		return {
			totalRows:0,
			currentPage: 0,
			ClientErr: '',
			WarehouseErr: '',
			qtyError: true,
			qtyshowerror: false,
			showSTNModel: false,
			viewSTNmodal: false,
			checkStockmodel: false,
			addSTNmodal: false,
			showSelectClient: false,
			showSelectWarehouse: false,

			listTransportData: [],
			listClientData: [],
			listSTNData: [],
			listSourceFCData: [],
			listDestinationFCData: [],
			liststatusData: [{
				'status': 'created'
			}, {
				'status': 'confirmed'
			}, {
				'status': 'rackout'
			}],
			listMRPData: {},
			warehousedata: [],

			STNDetails: [],
			sourceWarehouseDetails: [],
			destinationWarehouseDetails: [],
			Details: [],
			stnidDetails: [],

			pageno: 0,
			pageCount: 0,
			pageLimit: 10,
			noofrows: 2,

			stnNo: '',
			STNaction: '',
			products: [],
			taken: [],
			source: '',
			deepSource: '',
			STNID: '',
			creationdate: '',
			sourceFC: '',
			destinationFC: '',
			transporter: '',
			status: '',
			requireddate: '',
			invoice_items: [],

			productid: '',
			client: '',
			clientid: '',
			warehouse: '',
			warehouseid: '',

			searchSTNID: '',
			searchclient: '',
			searchsourceFC: '',
			searchdestinationFC: '',
			searchtransporter: '',
			searchcreationdate: '',
			resultCount: '',
			createdbyuserid: '',
			userwarehouse: '',

			isLoading: false,
			isfound: '',
		}
	},
	//display date in DD-MM-YYYY format
	filters: {
		moment: function(date) {
			return moment(date).format('DD-MM-YYYY');
		}
	},
	created: function() {},
	computed: {
		//display table rows
		STNsubtotal: function() {
			let subtotal = [];

			Object.entries(this.STNDetails).forEach(([key, val]) => {
				subtotal.push(val.subtotal) // the value of the current key.
			});
			return subtotal.reduce(function(subtotal, num) {
				return Number(subtotal) + Number(num)
			}, 0);
		},

		itemsWithSubTotal() {
			return this.invoice_items.map(item => ({
				item,
			}))
		},
		//disables table rows when clientname and sourcewarehouse are absent
		isDisabled() {
			if (this.client && this.sourceFC) {
				return false;
			} else {
				return true;
			}
		}
	},
	// when a page loads,mounted() will be call
	mounted() {
		var permissionEncrypt = window.localStorage.getItem('userdetail');
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);

		this.createdbyuserid = userdetail.userid;
		this.isLoading = false;
		this.pageno = 0;
		this.client = window.localStorage.getItem('selectedClient')
		this.clientid =this.client

		//this.getClientList();
		this.user_type = userdetail.utype;
		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				// this.getClientList();
				this.getWarehouseList();
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				this.client = this.clientid;
				 this.getWarehouseList();
				this.showSelectWarehouse = true;
				break;

			case 'warehouse_user':
				this.loginUserEmail = userdetail.email;
				this.userwarehouse = userdetail.warehouseid;
				this.searchdestinationFC = userdetail.warehouseid;
				this.destinationFC = userdetail.warehouseid;
				this.warehouse = userdetail.warehouseid;
				this.showSelectClient = true;
				// this.getClientList();

				var roleids = userdetail.roleid.split(',');
				for (var i = 0; i < roleids.length; i++) {
					if (roleids[i] == 40) {
						this.purchasingManager = parseInt(roleids[i]);
					}
					if (roleids[i] == 41) {
						this.isInwardUserForPO = true;
					}
				}
				break;

			default:
				this.$alertify.error(this.$t('common.unauthorisedError'));
				break
		}

		// this.getTransportList();
		// this.getSTNData();

		if (document.getElementById('stnstnaction'))
			document.getElementById('stnstnaction').removeAttribute('disabled');

	},
	methods: {
		// clientSelected() {
		// 	this.invoice_items = [];
		// 	this.listMRPData = [];
		// 	if (this.client != this.searchclient) {
		// 		this.client = this.searchclient;
		// 		this.listSourceFCData = [];
		// 		this.listDestinationFCData = [];
		// 	} else
		// 		this.client = this.searchclient;

		// 	this.getWarehouseList();
		// 	this.getSTNData();

		// },

		warehouseSelected() {
			this.invoice_items = [];
			this.listMRPData = [];
			this.sourceFC = this.searchsourceFC;
			this.getTransportList();
			if (this.warehouseid) {
				if (this.clientid) {
					this.getSTNData();
				} else {
					this.getClientList();
				}
			}
		},

		// getClientList() {
		// 	var userToken = window.localStorage.getItem('userToken');
		// 	var myStr = userToken.replace(/"/g, '');
		// 	this.pageno = 0;

		// 	this.input = ({
		// 		warehouseid: this.warehouse,
		// 	});

		// 	axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr,
		// 			}
		// 		})
		// 		.then(result => {
		// 			this.listClientData = result.data.data;
		// 		}, error => {
		// 			console.error(error);
		// 		});
		// },
		getWarehouseList() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.pageno = 0;

			this.input = ({
				clientid: this.client,
			});

			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					//this.listWarehouseData = result.data.data;
					this.listSourceFCData = result.data.data;
					this.listDestinationFCData = result.data.data;
				}, error => {
					console.error(error)
				})
		},
		//to get STN list
		getSTNData() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');

			if (this.user_type == 'client_user') {
				this.client = this.clientid;
				this.searchclient = this.clientid;
			}


			if (window.localStorage.getItem('selectedClient')==='undefined') {
				this.$alertify.error('Please Select Client')
				this.pageCount = 0;
				return false;
			}

			if (this.searchSTNID != '' && !(this.searchSTNID > 0)) {
				this.$alertify.error(this.$t('stockTransfer.stnIdError'));
				return false;
			}

			if (typeof this.searchcreationdate == 'undefined' || this.searchcreationdate == '')
				this.searchcreationdate = '';

			this.isLoading = true;

			this.input = ({
				userwarehouse: this.userwarehouse,
				offset: this.pageno,
				limit: this.pageLimit,
				stnid: this.searchSTNID,
				clientid: this.clientid,
				sourcewarehouseid: this.searchsourceFC,
				destinationwarehouseid: this.searchdestinationFC,
				transportername: this.searchtransporter,
				status: this.status,
				creationdate: this.dateFormat(this.searchcreationdate),
			})
			this.isLoading = true;
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getSTNlist',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					this.listSTNData = result.data.data;
					this.isLoading = false;
					this.totalRows = result.data.totalRows;
					this.resultCount = result.data.totalRows
					if (result.data.count == 0)
						this.pageCount = 0
					if (this.totalRows <= this.pageLimit) {
						this.pageCount = 1
					} else {
						this.pageCount = Math.ceil(this.totalRows / this.pageLimit);
					}

					this.warehousedata = result.data.WarehouseDetails[0];
					var listClients = result.data.clintdata;
					for (var i = 0; i < this.listSTNData.length; i++) {
						var objindex = this.findObjectByKey(listClients, "clientid", this.listSTNData[i].clientid);
						this.listSTNData[i]['clientname'] = objindex.clientname;
						this.listSTNData[i]['sourcewarehousename'] = this.warehousedata[this.listSTNData[i].sourcewarehouse].warehousename;
						this.listSTNData[i]['destinationwarehousename'] = this.warehousedata[this.listSTNData[i].destinationwarehouse].warehousename;
						//  let objindex = array.indexOf(objindex);
					}
					this.isLoading = false;
				}, error => {
					console.error(error)
				})
		},
		//open new form(popup)
		dateFormat(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD');
		},
		twoDecimal(val) {
			return val.toFixed(2);
		},
		searchSetting(str) {
			switch (str) {
				case 1:
					this.client = this.searchclient;
					this.getSourceFCList();
					this.getDestinationFCList();
					break;
				case 2:
					this.sourceFC = this.searchsourceFC;
					this.getTransportList();
					break;
				default:
					break;
			}
		},
		findObjectByKey(array, key, value) {
			for (var j = 0; j < array.length; j++) {
				if (array[j][key] == value) {
					return array[j];
				}
			}
			return null;
		},

		onChangeClientWarehouse() {
			this.STNaction = 'add';
			//this.addSTNmodal = true;
			this.$validator.reset();
			this.errors.clear();
			this.listMRPData = {};
			this.invoice_items = [];
			for (var x = 0; x < this.noofrows; x++) {
				this.invoice_items.push({
					productid: "",
					productname: "",
					productdescription: "",
					mrp: '',
					quantity: '',
					line: '',
					primaryuom: ''
				});
			}

		},
		addNewSTN() {
			this.STNaction = 'add';
			this.addSTNmodal = true;
			this.Clearform();
			this.$validator.reset();
			this.errors.clear();
			this.listMRPData = {};
			this.invoice_items = [];

			for (var x = 0; x < this.noofrows; x++) {
				this.invoice_items.push({
					productid: "",
					productname: "",
					productdescription: "",
					mrp: '',
					quantity: '',
					line: '',
					primaryuom: ''
				});
			}
		},
		getSubStr(str, start, end) {
			return str.substring(start, end);
		},
		//to close add (new) form
		closeAddSTNModal() {
			this.addSTNmodal = false
		},
		//to close edit form
		closeEditSTNModal() {
			this.addSTNmodal = false
		},
		// adds table rows
		addRow: function() {
			this.invoice_items.push({
				productid: "",
				productname: "",
				productdescription: "",
				mrp: '',
				quantity: '',
				line: '',
				primaryuom: '',
			})
		},
		//on table onchange calling this function
		sourceChanged: function(e) {
			var selectedInd = e.target.getAttribute('ind');
			var newSource = e.target.value;

			if (selectedInd > 0 && this.qtyError == true && this.deepSource.productid != '' && typeof this.deepSource.productid != 'undefined') {

				this.qtyshowerror = true;
				this.$alertify.error(this.$t('stockTransfer.quantityError'));
				this.invoice_items[selectedInd].productname = '';
				this.deepSource.productid = ''
				return false;
			}
			for (var i = 0; i < this.products.length; i++) {
				if (this.products[i].productname == newSource) {
					this.deepSource = this.products[i];
					if (!this.deepSource.primaryuom)
						this.deepSource.primaryuom = '';
					this.invoice_items[selectedInd].productname = this.deepSource.productname;
					this.invoice_items[selectedInd].productdescription = this.deepSource.productdescription;
					this.invoice_items[selectedInd].productid = this.deepSource.productid;
					this.invoice_items[selectedInd].mrp = this.deepSource.mrp;
					this.invoice_items[selectedInd].primaryuom = this.deepSource.primaryuom;
					this.invoice_items[selectedInd].quantity = this.deepSource.quantity;
					this.invoice_items[selectedInd].line = this.deepSource.line;
				}
			}
			this.taken.push(this.invoice_items[selectedInd].productid);
			this.qtyError = true;
			this.getMRP(this.deepSource.productid, this.client, this.sourceFC, selectedInd);
		},
		//to get Product Details
		getProducts: function(e) {
			var userToken = window.localStorage.getItem('userToken');
			var rowsInd = e.target.getAttribute('ind');
			var myStr = userToken.replace(/"/g, '');
			var txt = encodeURIComponent(e.target.value.trim());
			if (txt.length == 0) {
				this.invoice_items[rowsInd].productname = '';
				this.invoice_items[rowsInd].productdescription = '';
				this.invoice_items[rowsInd].productid = '';
				this.invoice_items[rowsInd].mrp = '';
				this.invoice_items[rowsInd].primaryuom = '';
				this.invoice_items[rowsInd].quantity = '';
				this.invoice_items[rowsInd].line = '';
			}
			if (txt.length < 3) {
				return false;
			}

			this.input = ({
				"warehouseid": this.sourceFC,
				"clientid": this.client
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getSTNProduct/' + txt,
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {

					this.products = result.data;
				}, error => {
					console.error(error);
				})
		},
		getSTNRowDetails(data, client) {
			this.showSTNModel = true;
			this.viewSTNmodal = true;
			this.stnid = data;
			this.getSTNDetails(data, client)
			this.$validator.reset();
			this.errors.clear();
		},
		//to close add (new) form
		closeviewSTNmodal() {
			this.viewSTNmodal = false
		},
		//to get STN list
		getSTNDetails(data, client) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.pageno = 0
			this.input = ({
				'stnid': data,
				"clientid": this.clientid 
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getSingleSTNDetails',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					this.STNDetails = result.data.data.data[1].details;
					this.stnidDetails = result.data.data.data[1].details[0].stnid;

					this.Details = result.data.data.data[0][0];
					this.warehouseDetails = result.data.data.data[1].WarehouseDetails;

					var swarehouse = result.data.data.data[0][0].sourcewarehouse;
					var dwarehouse = result.data.data.data[0][0].destinationwarehouse;

					this.sourceWarehouseDetails = result.data.data.data[2].WarehouseDetails[swarehouse];
					this.destinationWarehouseDetails = result.data.data.data[2].WarehouseDetails[dwarehouse]
				}, error => {
					console.error(error)
				})
		},

		getMRP(productid, clientid, warehouseid, ind) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.pageno = 0
			this.input = ({
				productid: this.deepSource.productid,
				clientid: this.clientid,
				warehouseid: this.sourceFC
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getStockAvilability',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					//if(!this.listMRPData[this.deepSource.productid])
					{
						this.listMRPData[this.deepSource.productid] = [];
						var value = [];
						for (var i = 0; i < result.data.data.data.length; i++) {
							value.push({
								"mrp": result.data.data.data[i].mrp,
								"totalstock": result.data.data.data[i].totalstock
							});
						}
						this.listMRPData[this.deepSource.productid] = value
						var select = document.getElementById(ind);

						for (var j = select.options.length; j >= 0; j--) {
							select.remove(j);
						}

						var opt = document.createElement('option');
						opt.value = '';
						opt.innerHTML = "MRP";
						opt.selected = true;
						select.appendChild(opt);
						//select.selectedIndex = 0;

						for (var i = 0; i < value.length; i++) {
							opt = document.createElement('option');
							opt.value = value[i].mrp;
							opt.innerHTML = "Rs." + value[i].mrp + " (" + value[i].totalstock + ")";
							select.appendChild(opt);
						}
						//  select.options.selectedIndex = 0;
					}
				}, error => {
					console.error(error)
				})
		},

		CheckQuantity(index) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.pageno = 0;
			if (!(this.invoice_items[index].mrp > 0)) {
				this.$alertify.error(this.$t('stockTransfer.mrpError'));
				this.invoice_items[index].quantity = '';
				return false;
			}
			this.input = ({
				productid: this.invoice_items[index].productid,
				clientid: this.clientid,
				warehouseid: this.sourceFC
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getStockAvilability',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					for (var i = 0; i < result.data.data.data.length; i++) {
						if (result.data.data.data[i].mrp == this.invoice_items[index].mrp)
							break;
					}
					this.listQtyData = result.data.data.data[i].totalstock
					if ((this.invoice_items[index].quantity) > (this.listQtyData) || this.invoice_items[index].quantity <= 0) {
						this.$alertify.error(this.$t('stockTransfer.invalidQuantError'));
						this.invoice_items[index].quantity = '';
					}
					if (this.invoice_items.quantity == '') {
						this.$alertify.error(this.$t('stockTransfer.quantityError'));
						this.qtyError = true;
					}
				}, error => {
					console.error(error)
				})
		},

		checkqty(qty) {
			if (qty == '') {
				this.$alertify.error(this.$t('stockTransfer.quantityError'));
				this.qtyError = true;
			} else {
				this.qtyError = false;
			}
		},
		//to search the entered PO
		checkStockAvailability() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				productid: this.deepSource.productid,
				clientid: this.clientid,
				warehouseid: this.sourceFC
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getStockAvilability',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			}).then((response) => {
				if (response.data.data.errorCode == 0) {} else {}
			})
		},
		//to deletes target record
		removeRow: function(index) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'deleteSTNElement',
					'data': {
						'userid': this.createdbyuserid,
						"stnid": this.stnid.trim(),
						"productid": this.invoice_items[index].productid,
						"itemid": this.invoice_items[index].itemid,
						"userwarehouse": this.userwarehouse,
					},
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					this.invoice_items.splice(index, 1);
					this.$alertify.success(this.$t('stockTransfer.stnDeleteSuccessMsg'))
				});
		},
		clearRow(index) {
			this.invoice_items.splice(index, 1);
		},

		getTransportList() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			if (this.user_type == 'client_user' && this.client == '')
				this.client = this.clientid;
			this.pageno = 0;
			this.input = ({
				"warehouseid": this.sourceFC,
				"clientid": this.clientid
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getTransportList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					this.listTransportData = result.data.data.data
				}, error => {
					console.error(error)
				})
		},

		getSourceFCList() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.pageno = 0
			this.input = ({
				"clientid": this.clientid
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getClientWarehouseList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					this.listSourceFCData = result.data.data.data
					//this.warehouseid = result.data.data.data.warehouseid;
				}, error => {
					console.error(error)
				})
		},

		getDestinationFCList() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.pageno = 0
			this.input = ({
				"clientid": this.clientid 
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getClientWarehouseList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					this.listDestinationFCData = result.data.data.data
					//this.warehouseid = result.data.data.data.warehouseid;
					let totalRows = result.data.count
				}, error => {
					console.error(error)
				})
		},

		// save form fields in mysql database
		saveSTN(mode) {
			document.getElementById('stnstnaction').setAttribute('disabled', true);
			var productDetails = [];
			var checkProduct = [];
			for (var x = 0; x < this.invoice_items.length; x++) {
				var productid = this.invoice_items[x].productid;
				if (productid == '')
					continue;
				var mrp = this.invoice_items[x].mrp;

				if (this.invoice_items[x].mrp == '' || typeof this.invoice_items[x].mrp == 'undefined') {
					this.$alertify.error(this.$t('stockTransfer.mrpError'));
					document.getElementById('stnstnaction').removeAttribute('disabled');
					return false;
				}
				if (this.invoice_items[x].quantity == '' || typeof this.invoice_items[x].quantity == 'undefined') {
					this.$alertify.error(this.$t('stockTransfer.quantityError'));
					document.getElementById('stnstnaction').removeAttribute('disabled');
					return false;
				}
				for (var j = 0; j < checkProduct.length; j++) {
					if (checkProduct[j].productid == productid && checkProduct[j].mrp == mrp) {
						this.$alertify.error(this.$t('stockTransfer.productSameMrpErrorMsg'));
						document.getElementById('stnstnaction').removeAttribute('disabled');
						//break;
						return false;
					}
				}
				checkProduct.push({
					"productid": productid,
					"mrp": mrp
				});
			}
			if (this.user_type == 'warehouse_user')
				this.destinationFC = this.userwarehouse;

			if (this.sourceFC == this.destinationFC) {
				this.$alertify.error(this.$t('stockTransfer.warehouseNotToBeSameErrorMsg'));
				document.getElementById('stnstnaction').removeAttribute('disabled');
				return false;
			}
			var dateArr = [];
			var today = new Date();
			var requireddate = new Date(this.requireddate);
			requireddate.setHours(23, 59, 59, 59);

			if (Date.parse(requireddate) >= Date.parse(today)) {
				dateArr = requireddate;
			} else {
				this.$alertify.error(this.$t('stockTransfer.invalidReqDate'));
				document.getElementById('stnstnaction').removeAttribute('disabled');
				return false;
			}
			for (var x = 0; x < this.invoice_items.length; x++) {
				if (this.invoice_items[x].productid != '') {
					productDetails[x] = {
						productid: this.invoice_items[x].productid,
						productname: this.invoice_items[x].productname,
						productdescription: this.invoice_items[x].productdescription,
						mrp: this.invoice_items[x].mrp,
						uom: this.invoice_items[x].primaryuom,
						requestedqty: this.invoice_items[x].quantity
					};
				}
			}
			if (productDetails.length == 0) {
				this.$alertify.error(this.$t('stockTransfer.atleastOneProductSelectErrorMsg'));
				document.getElementById('stnstnaction').removeAttribute('disabled');
				return false;
			}

			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				'userid': this.createdbyuserid,
				'clientid': this.clientid,
				'sourcewarehouseid': this.sourceFC,
				'destinationwarehouseid': this.destinationFC,
				'requireddate': this.requireddate,
				'transportername': this.transporter,
				'lineDetails': productDetails,
				'confirm': mode
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'saveStockTransfer',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then((response) => {
					if (response.data.status = 200) {
						// Call esalstic to insert
						axios.post(apiUrl.api_url + 'elsstn', {
							'clientid': this.client,
							'stnid': response.data.data.stnid,
						}).then((elasticResp) => {
							this.$alertify.success(this.$t('stockTransfer.stnCreatedSuccessMsg'))
							this.stnNo = response.data.message;

							this.resetFormData();
							document.getElementById('stnstnaction').removeAttribute('disabled');
							this.addSTNmodal = false;

						});

					} else {
						(response.dataarr.status != 200)
						this.$alertify.error(this.$t('stockTransfer.stnExistMsg'))
						document.getElementById('stnstnaction').removeAttribute('disabled');
					}
				})
				.catch((httpException) => {
					document.getElementById('stnstnaction').removeAttribute('disabled');
					console.error('exception is:::::::::', httpException)
				})
		},
		updateSTN(mode) {
			document.getElementById('stnstnaction').setAttribute('disabled', true);
			var productDetails = [];
			var checkProduct = [];
			for (var x = 0; x < this.invoice_items.length; x++) {
				var productid = this.invoice_items[x].productid;
				if (productid == '')
					continue;
				var mrp = this.invoice_items[x].mrp;

				if (this.invoice_items[x].mrp == '' || typeof this.invoice_items[x].mrp == 'undefined') {
					this.$alertify.error(this.$t('stockTransfer.mrpError'));
					document.getElementById('stnstnaction').removeAttribute('disabled');
					return false;
				}
				if (this.invoice_items[x].quantity == '' || typeof this.invoice_items[x].quantity == 'undefined') {
					this.$alertify.error(this.$t('stockTransfer.quantityError'));
					document.getElementById('stnstnaction').removeAttribute('disabled');
					return false;
				}
				for (var j = 0; j < checkProduct.length; j++) {
					if (checkProduct[j].productid == productid && checkProduct[j].mrp == mrp) {
						this.$alertify.error(this.$t('stockTransfer.productSameMrpErrorMsg'));
						document.getElementById('stnstnaction').removeAttribute('disabled');
						//break;
						return false;
					}
				}
				checkProduct.push({
					"productid": productid,
					"mrp": mrp
				});
			}

			if (this.sourceFC == this.destinationFC) {
				this.$alertify.error(this.$t('stockTransfer.warehouseNotToBeSameErrorMsg'));
				document.getElementById('stnstnaction').removeAttribute('disabled');
				return false;
			}

			var dateArr = [];
			var today = new Date();
			var requireddate = new Date(this.requireddate);
			requireddate.setHours(23, 59, 59, 59);
			if (Date.parse(requireddate) >= Date.parse(today)) {
				dateArr = requireddate;
			} else {
				this.$alertify.error(this.$t('stockTransfer.invalidReqDate'));
				document.getElementById('stnstnaction').removeAttribute('disabled');
				return false;
			}

			for (var x = 0; x < this.invoice_items.length; x++) {
				if (this.invoice_items[x].productid != '') {
					productDetails[x] = {
						productid: Number(this.invoice_items[x].productid),
						productname: this.invoice_items[x].productname,
						productdescription: this.invoice_items[x].productdescription,
						mrp: this.invoice_items[x].mrp,
						uom: this.invoice_items[x].primaryuom,
						requestedqty: this.invoice_items[x].quantity,
						itemid: this.invoice_items[x].itemid,
					};
				}
			}
			if (productDetails.length == 0) {
				this.$alertify.error(this.$t('stockTransfer.atleastOneProductSelectErrorMsg'));
				document.getElementById('stnstnaction').removeAttribute('disabled');
				return false;
			}
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'updateSTN',
					'data': ({
						'stnid': this.stnid.trim(),
						'userid': this.createdbyuserid,
						'clientid': this.clientid,
						'sourcewarehouseid': this.sourceFC,
						'destinationwarehouseid': this.destinationFC,
						'requireddate': this.requireddate,
						'transportername': this.transporter,
						'lineDetails': productDetails,
						'confirm': mode
					}),
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then((response) => {
					if (response.data.status = 200) {

						// Call esalstic to Update STN
						axios.post(apiUrl.api_url + 'elsstn', {
							'clientid': this.clientid,
							'stnid': response.data.data.stnid,
						}).then((elasticResp) => {

							this.$alertify.success(this.$t('stockTransfer.stnUpdatedSuccessMsg'))
							this.stnNo = response.data.message;
							this.addSTNmodal = false;
							document.getElementById('stnstnaction').removeAttribute('disabled');
							this.resetFormData();

						});
					} else {
						(response.dataarr.status != 200)
						document.getElementById('stnstnaction').removeAttribute('disabled');
						this.$alertify.error(this.$t('stockTransfer.stnExistMsg'))
					}
				})
				.catch((httpException) => {
					document.getElementById('stnstnaction').removeAttribute('disabled');
					console.error('exception is:::::::::', httpException)
				})
		},
		//to get target id in edit action
		getSTNRowData(data, client) {
			this.$validator.reset();
			this.errors.clear();
			this.STNaction = 'edit';
			this.addSTNmodal = true;
			this.listMRPData = {};
			this.stnid = data;
			this.editSTN(data, client);
		},
		//update form fields
		editSTN(data, client) {
			var stndata = {};
			this.input = ({
				'stnid': data,
				"clientid": client
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getSingleSTNDetails',
					'data': this.input
				})
				.then(result => {

					this.stndata = result.data.data.data[0][0];
					this.client = this.stndata.clientid;
					this.getWarehouseList()
					// this.getSourceFCList();
					// this.getDestinationFCList();
					this.stnid = data;
					this.requireddate = new Date(this.stndata.requireddate);
					this.sourceFC = this.stndata.sourcewarehouse;
					this.getTransportList();
					this.destinationFC = this.stndata.destinationwarehouse;
					this.transporter = this.stndata.transportername;
					this.stndetails = result.data.data.data[1]['details'];
					this.listMRPData = {};
					this.itemarr = [];
					for (var i = 0; i < this.stndetails.length; i++) {
						this.itemarr.push(this.stndetails[i].productid);
					}
					var productString = this.itemarr.toString();
					var userToken = window.localStorage.getItem('userToken');
					var myStr = userToken.replace(/"/g, '');

					axios({
							method: 'POST',
							'url': apiUrl.api_url + 'getWarehouseProductStock',
							'data': ({
								'clientid': this.stndata.clientid,
								"warehouseid": this.stndata.sourcewarehouse,
								"searchstring": productString
							}),
							headers: {
								'Authorization': 'Bearer ' + myStr,
							}
						})
						.then(stockResult => {
							var listMRPData = {};
							var stockResult = stockResult.data.data.data;
							for (var i = 0; i < stockResult.length; i++) {
								var tempkey = stockResult[i].productid;
								if (!listMRPData[tempkey]) {
									listMRPData[tempkey] = []
									listMRPData[tempkey].push({
										"totalstock": stockResult[i].totalstock,
										"mrp": stockResult[i].mrp
									});
								} else {
									listMRPData[tempkey].push({
										"totalstock": stockResult[i].totalstock,
										"mrp": stockResult[i].mrp
									});
								}
							}

							this.listMRPData = listMRPData;
							this.invoice_items = [];
							for (var i = 0; i < this.stndetails.length; i++) {
								if (!listMRPData[this.stndetails[i].productid]) {
									listMRPData[this.stndetails[i].productid] = [];
									listMRPData[this.stndetails[i].productid].push({
										"totalstock": "0",
										"mrp": this.stndetails[i].mrp
									});
								}
								this.invoice_items.push({
									itemid: this.stndetails[i].itemid,
									productid: this.stndetails[i].productid,
									productname: this.stndetails[i].productname,
									productdescription: this.stndetails[i].productdescription,
									mrp: this.stndetails[i].mrp,
									quantity: this.stndetails[i].requestedqty,
									primaryuom: this.stndetails[i].uom
								})
							}
						});
				});
		},
		getPaginationData(currentPage) {
			this.pageno = (currentPage - 1) * this.pageLimit;
			this.getSTNData()
		},
		onSubmit: function() {
			this.$validator.validateAll().then(() => {
				console.log('form is valid')
			}).catch(() => {
				console.log('errors exist')
			});
		},
		Clearform() {
			this.requireddate = null;
			this.client = '';
			this.sourceFC = '';
			this.destinationFC = '';
			this.transporter = '';
			this.listMRPData = {};
			this.invoice_items = [];
		},
		//closes modal(View STN popup)
		hidecheckStockmodel() {
			this.checkStockmodel = false;
		},
		//opens modal(View STN popup)
		opencheckStockmodel() {
			this.checkStockmodel = true;
		},
		//to reset search form
		resetFormData() {
			this.searchSTNID = '';
			this.searchclient = '';
			this.searchsourceFC = '';
			this.searchdestinationFC = '';
			this.searchtransporter = '';
			this.status = '';
			this.searchcreationdate = '';
			this.pageno = 0;
			this.pageCount = 0;
			this.totalRows=0;
			this.listSTNData = [];
		},
	}
}



// WEBPACK FOOTER //
// ./src/views/components/stocktransfer/stocktransfer.component.js